'use strict';

const { showProductTileSwatchImage, showProductTileAltImage, showProductTileFirstImage, markViewedProducts } = require('../../../search/search.js');

showProductTileSwatchImage();
showProductTileAltImage();
showProductTileFirstImage();
markViewedProducts();
